import { useCallback, useRef, useState, ReactElement } from "react"
import { CloseButton } from "../Components/CloseButton"
import { Icon, Icons, IconType } from "../Components/Icon"
import { classNames } from "../Components"
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
export type OnSelectCallback = (value?: any) => void;

export interface SelectOption {
  className?: string;
  disabled?: boolean;
  icon?: ReactElement | IconType;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  value: any;
}

interface SelectProps {
  button: ReactElement | string;
  customValue?: string;
  // Shown in place of the option list when there is nothing to select, so a picker
  // whose options filter down to nothing does not open as a bare panel (#1213).
  emptyText?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  value: any;
  name?: string;
  onSelect: OnSelectCallback;
  options: SelectOption[];
  readOnly?: boolean;
  title?: string;
  className?: string;
  initOpen?: boolean;
}

export function Select({ button, customValue, emptyText, name, onSelect, options, readOnly, title, value, className, initOpen }: SelectProps) {
  const customValueRef = useRef<HTMLInputElement | null>(null);
  const [selected, setSelected] = useState(initOpen ?? false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  const select = useCallback((value?: any) => {
    onSelect(value);
    setSelected(false);
  }, [onSelect]);

  return (
    <span className={classNames(["Select", selected && "selected", readOnly && "readOnly", className])}>
      {name && <input type="hidden" name={name} value={value} />}
      {!readOnly && (
        <div className="Select-options-container">
          <div className="Select-options">
            <CloseButton key={"close"} onClick={() => setSelected(false)} />
            {options.map((option) => {
              if (option) {
                return (
                  <div key={`option-${option.value}`} className={classNames(["Select-option", option.disabled && "disabled", option.className])} data-value={option.value} onClick={() => !option.disabled && select(option.value)}>
                    {option.icon && (typeof option.icon == "string" ? <Icon icon={option.icon} /> : option.icon)}
                    {option.title}
                  </div>
                );
              }
              return;
            })}
            {emptyText && options.length < 1 && !customValue && (
              <div className="Select-option Select-option-empty disabled">{emptyText}</div>
            )}
            {customValue && (
              <div className="Select-option Select-option-custom">
                <Icon className="Select-custom-value-button" icon={Icons.Enter} onClick={() => select(customValueRef.current?.value)} />
                <input className="Select-custom-value" placeholder={customValue} ref={customValueRef} />
              </div>
            )}
          </div>
        </div>
      )}
      <div className="button" onClick={() => !readOnly && setSelected(!selected)} title={title}>
        {button}
      </div>
    </span>
  );
}
